
import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for ArtistsCatalog Action/Mutation Types. Use it in   artists/actions.js, artists/mutations.js and the Vuex Host Component 
export const ArtistsCatalogData = createActionTypeModel('ArtistsCatalogData');

export const ArtistsCatalogListData=createActionTypeModel('ArtistsCatalogListData');

export const CatalogArtistsDetails=createActionTypeModel('CatalogArtistsDetails');

export const ArtistRelatedContacts=createActionTypeModel('ArtistRelatedContacts');

export const DefaultCredit=createActionTypeModel('DefaultCredit');

export const CatalogRelease=createActionTypeModel('CatalogRelease');

export const ArtistBookingArtist=createActionTypeModel('ArtistBookingArtist');

export const ArtistMetaData=createActionTypeModel('ArtistMetaData');

export const SET_ARTIST_PRODUCT_FILES = 'SET_ARTIST_PRODUCT_FILES';

export const SET_ARTIST_ARTWORK ="SET_ARTIST_ARTWORK";
